import 'autosize';
import 'bootstrap';
import './ajax_contact.js';
import './admin_login.js';
import 'blueimp-gallery/js/jquery.blueimp-gallery';

// import local dependencies
import Router from './util/Router';
import home from './routes/home';
import common from './routes/common';
import dashboard from './routes/dashboard';
import contemporary from './routes/contemporary';
import notfound from './routes/notfound';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  home,
  common,
  dashboard,
  contemporary,
  notfound,
});

$(document).ready(() => {
  // console.log('Hello world');
  routes.loadEvents()
});
